export default __webpack_public_path__ + "static/media/word_format@2x.2838a80e.png";